module App.Classes {
    export class CustomStorage implements Storage {
        constructor() {
            this.clear();
        }

        private customerStorage;

        [index: string]: any;

        clear(): void {
            this.customerStorage = {}
        }

        getItem = (key: string) => {
            return this.customerStorage[key];
        }

        key(index: number): string { throw new Error("Not implemented"); }

        removeItem = (key: string): void => {
            if (this.customerStorage[key])
                delete this.customerStorage[key];
        }

        setItem = (key: string, data: string): void => {
            this.customerStorage[key] = data;
        }

        get length(): number {
            return Object.keys(this.customerStorage).length;
        }

    }
}